import { useEffect } from "react";

export const useUpdateTabsInfo = (props) => {
  const {
    storage,
    action
  } = props && props
  useEffect(() => {
    const onStorageChange = (event) => {
      if (event.key === storage) {
        const data = JSON.parse(event.newValue || '{}');
        action && action(data)
      }
    };

    window.addEventListener('storage', onStorageChange);

    return () => {
      window.removeEventListener('storage', onStorageChange);
    };
  }, []);
}